/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './entity';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "regulator": {
        "nested": {
          "action": {
            "nested": {
              "v1": {
                "nested": {
                  "LocalizedString": {
                    "fields": {
                      "translations": {
                        "type": ".squareup.regulator.action.v1.LocalizedString.Translation",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Translation": {
                        "fields": {
                          "locale": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "text": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "AuditLogInputMapping": {
                    "fields": {
                      "inputForTo": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "inputForFrom": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "inputForComment": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ActionMetadata": {
                    "fields": {
                      "description": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "entityType": {
                        "type": ".squareup.regulator.action.v1.Entity.Type",
                        "id": 3,
                        "rule": "optional"
                      },
                      "featureFlag": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "registryGroup": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "auditLogEntryTemplate": {
                        "type": ".squareup.regulator.action.v1.LocalizedString",
                        "id": 6,
                        "rule": "optional"
                      },
                      "auditLogInputMapping": {
                        "type": ".squareup.regulator.action.v1.AuditLogInputMapping",
                        "id": 7,
                        "rule": "optional"
                      },
                      "actionId": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.LocalizedString && !$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.LocalizedString?.nested?.Translation && !$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.AuditLogInputMapping && !$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.ActionMetadata) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LocalizedString @ squareup/regulator/action/v1/meta.proto at 10:1
 */
export const LocalizedString = $root.lookupType('squareup.regulator.action.v1.LocalizedString');
fixType(LocalizedString);
Builder.createAndAttachToType(LocalizedString);
/**
 * SOURCE Translation @ squareup/regulator/action/v1/meta.proto at 11:3
 */
LocalizedString.Translation = $root.lookupType('squareup.regulator.action.v1.LocalizedString.Translation');
fixType(LocalizedString.Translation);
Builder.createAndAttachToType(LocalizedString.Translation);
/**
 * SOURCE AuditLogInputMapping @ squareup/regulator/action/v1/meta.proto at 18:1
 */
export const AuditLogInputMapping = $root.lookupType('squareup.regulator.action.v1.AuditLogInputMapping');
fixType(AuditLogInputMapping);
Builder.createAndAttachToType(AuditLogInputMapping);
/**
 * SOURCE ActionMetadata @ squareup/regulator/action/v1/meta.proto at 24:1
 */
export const ActionMetadata = $root.lookupType('squareup.regulator.action.v1.ActionMetadata');
fixType(ActionMetadata);
Builder.createAndAttachToType(ActionMetadata);